import { Link } from 'react-router-dom';
import { PageHero } from '@/components/PagePlaceholder';

const FAQ: { q: string; a: React.ReactNode }[] = [
  {
    q: 'Do I have to pay to use BingeBox?',
    a: <>No — anyone can browse the catalog and watch previews for free. A subscription unlocks full episodes.</>,
  },
  {
    q: 'What do the plans include?',
    a: (
      <>
        Individual (ad-supported), BingeBox (ad-free + downloads), and BingeBox+ (4K, early drops,
        biggest merch discount). Compare them on <Link to="/plans">Plans</Link>. You can add
        simultaneous streams to any plan.
      </>
    ),
  },
  {
    q: 'Monthly vs annual?',
    a: <>Monthly auto-renews and can be cancelled any time. Annual is a one-time payment for 12 months at a discount and does not auto-renew.</>,
  },
  {
    q: 'How do I change or cancel my plan?',
    a: <>Go to <Link to="/account">your account</Link> → Manage billing. Cancelling monthly keeps access until the end of the period you've paid for.</>,
  },
  {
    q: 'Why do some shows say "Coming soon"?',
    a: <>Those are upcoming titles or episodes that haven't been released yet. You'll see a release date when one is scheduled.</>,
  },
  {
    q: 'What audio and subtitle options are there?',
    a: <>Every show is produced in Japanese and English audio, and you can switch between them in the player.</>,
  },
  {
    q: 'How many people can watch at once?',
    a: <>That depends on your plan's simultaneous-stream count, which you can increase with the +stream add-on (up to 8).</>,
  },
  {
    q: 'I have a show idea or want to contribute.',
    a: <>Head to the <Link to="/dev">Dev Forums</Link> to pitch a show or request upload access.</>,
  },
];

export function HelpPage() {
  return (
    <div>
      <PageHero eyebrow="Help" title="How can we help?" subtitle="Answers to the most common questions about BingeBox." />
      <div className="container-page pb-16">
        <div className="mx-auto max-w-prose space-y-3">
          {FAQ.map(({ q, a }) => (
            <details key={q} className="card group p-5">
              <summary className="cursor-pointer list-none font-display font-bold text-ink marker:hidden">
                {q}
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-ink-muted">{a}</p>
            </details>
          ))}
          <p className="pt-4 text-center text-sm text-ink-muted">
            Still stuck? Email <a href="mailto:support@gobingebox.com" className="font-semibold text-brand-soft">support@gobingebox.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
